var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 60,
    viewBox: "0 0 50 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_761_20386)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 50C38.8071 50 50 38.8071 50 25C50 11.1929 38.8071 0 25 0C11.1929 0 0 11.1929 0 25C0 38.8071 11.1929 50 25 50Z",
    fill: "url(#paint0_linear_761_20386)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.54 31.83C32.17 31.38 34.23 29.32 34.67 26.68C35.23 23.27 35.23 19.79 34.67 16.38C34.23 13.75 32.17 11.68 29.54 11.23C24.29 10.34 18.92 10.34 13.67 11.23C11.04 11.68 8.98 13.74 8.54 16.38C7.98 19.79 7.98 23.27 8.54 26.68C8.92 28.99 10.55 30.86 12.71 31.59C12.71 31.59 13.21 33.23 12.65 35.18C12.5 35.71 13.06 36.17 13.56 35.93C14.62 35.43 16.15 34.4 17.58 32.33C21.56 32.67 25.58 32.5 29.53 31.83H29.54Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.61 26.9698C41.47 26.1298 41.07 25.3898 40.51 24.8098C39.94 24.2298 39.2 23.8398 38.36 23.6998C37.92 23.6298 37.48 23.5598 37.04 23.5098C36.97 24.6798 36.84 25.8498 36.65 27.0098C36.07 30.4798 33.36 33.2198 29.88 33.7998C28.36 34.0598 26.81 34.2498 25.27 34.3598C25.47 34.8598 25.77 35.2998 26.14 35.6698C26.71 36.2398 27.45 36.6398 28.29 36.7798C30.8 37.2098 33.35 37.3098 35.88 37.0898C36.79 38.3998 37.75 39.0598 38.43 39.3798C38.75 39.5298 39.11 39.2398 39.01 38.8998C38.88 38.4498 38.84 38.0298 38.84 37.6698C38.84 37.0398 38.97 36.6098 38.97 36.6098C40.35 36.1498 41.38 34.9598 41.62 33.4998C41.8 32.4198 41.89 31.3198 41.89 30.2298C41.89 29.1398 41.8 28.0498 41.62 26.9598L41.61 26.9698Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8101 24.0303C16.1908 24.0303 17.3101 22.911 17.3101 21.5303C17.3101 20.1496 16.1908 19.0303 14.8101 19.0303C13.4293 19.0303 12.3101 20.1496 12.3101 21.5303C12.3101 22.911 13.4293 24.0303 14.8101 24.0303Z",
    fill: "url(#paint1_linear_761_20386)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6001 24.0303C22.9808 24.0303 24.1001 22.911 24.1001 21.5303C24.1001 20.1496 22.9808 19.0303 21.6001 19.0303C20.2194 19.0303 19.1001 20.1496 19.1001 21.5303C19.1001 22.911 20.2194 24.0303 21.6001 24.0303Z",
    fill: "url(#paint2_linear_761_20386)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8599 21.5303C30.8599 22.911 29.7406 24.0303 28.3599 24.0303C26.9792 24.0303 25.8599 22.911 25.8599 21.5303C25.8599 20.1496 26.9792 19.0303 28.3599 19.0303C29.7406 19.0303 30.8599 20.1496 30.8599 21.5303Z",
    fill: "url(#paint3_linear_761_20386)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_761_20386)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 40,
    width: 32,
    height: 20,
    rx: 10,
    fill: "black",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6817 53.16C16.9883 53.16 16.355 52.9967 15.7817 52.67C15.2083 52.3367 14.755 51.8867 14.4217 51.32C14.095 50.7467 13.9317 50.1133 13.9317 49.42C13.9317 48.7267 14.095 48.0967 14.4217 47.53C14.755 46.9567 15.2083 46.5067 15.7817 46.18C16.355 45.8467 16.9883 45.68 17.6817 45.68C18.7617 45.68 19.655 46.07 20.3617 46.85L19.4117 47.77C18.9517 47.23 18.3783 46.96 17.6917 46.96C17.245 46.96 16.8383 47.0633 16.4717 47.27C16.105 47.47 15.815 47.7567 15.6017 48.13C15.395 48.5033 15.2917 48.9333 15.2917 49.42C15.2917 49.9067 15.395 50.3367 15.6017 50.71C15.815 51.0833 16.105 51.3733 16.4717 51.58C16.8383 51.78 17.245 51.88 17.6917 51.88C18.445 51.88 19.075 51.5667 19.5817 50.94L20.5417 51.85C20.1883 52.2767 19.7683 52.6033 19.2817 52.83C18.8017 53.05 18.2683 53.16 17.6817 53.16ZM21.514 45.84H22.824V47.65L22.744 48.54H22.824C22.9707 48.3 23.184 48.1067 23.464 47.96C23.744 47.8133 24.0474 47.74 24.374 47.74C24.994 47.74 25.4674 47.9267 25.794 48.3C26.1274 48.6667 26.294 49.1767 26.294 49.83V53H24.984V49.99C24.984 49.6633 24.894 49.41 24.714 49.23C24.5407 49.05 24.3074 48.96 24.014 48.96C23.6674 48.96 23.3807 49.1 23.154 49.38C22.934 49.66 22.824 50.0033 22.824 50.41V53H21.514V45.84ZM29.0408 53.16C28.5008 53.16 28.0575 53.0033 27.7108 52.69C27.3642 52.37 27.1908 51.9533 27.1908 51.44C27.1908 51.1 27.2808 50.8 27.4608 50.54C27.6408 50.28 27.8875 50.08 28.2008 49.94C28.5142 49.8 28.8608 49.73 29.2408 49.73C29.7675 49.73 30.2175 49.8067 30.5908 49.96V49.74C30.5908 49.46 30.4842 49.2333 30.2708 49.06C30.0642 48.8867 29.7842 48.8 29.4308 48.8C29.1908 48.8 28.9575 48.8567 28.7308 48.97C28.5108 49.0767 28.3275 49.22 28.1808 49.4L27.3408 48.74C27.5875 48.42 27.8975 48.1733 28.2708 48C28.6442 47.8267 29.0508 47.74 29.4908 47.74C30.2708 47.74 30.8642 47.92 31.2708 48.28C31.6775 48.64 31.8808 49.1667 31.8808 49.86V53H30.5908V52.48H30.5108C30.3575 52.68 30.1542 52.8433 29.9008 52.97C29.6542 53.0967 29.3675 53.16 29.0408 53.16ZM29.3508 52.14C29.7308 52.14 30.0308 52.02 30.2508 51.78C30.4775 51.5333 30.5908 51.2467 30.5908 50.92C30.2508 50.76 29.8942 50.68 29.5208 50.68C28.8408 50.68 28.5008 50.9333 28.5008 51.44C28.5008 51.6467 28.5742 51.8167 28.7208 51.95C28.8675 52.0767 29.0775 52.14 29.3508 52.14ZM35.2086 53.08C34.9553 53.08 34.722 53.0433 34.5086 52.97C34.2953 52.89 34.122 52.7833 33.9886 52.65C33.6753 52.35 33.5186 51.9233 33.5186 51.37V49.02H32.6286V47.9H33.5186V46.46H34.8286V47.9H36.0786V49.02H34.8286V51.13C34.8286 51.39 34.8853 51.5767 34.9986 51.69C35.092 51.7967 35.252 51.85 35.4786 51.85C35.6053 51.85 35.7086 51.8333 35.7886 51.8C35.8753 51.7667 35.9853 51.71 36.1186 51.63V52.91C35.832 53.0233 35.5286 53.08 35.2086 53.08Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_761_20386",
    x: -41,
    y: -10,
    width: 132,
    height: 120,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_761_20386"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_761_20386",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_761_20386",
    x1: -3.67211,
    y1: -4.50077e-7,
    x2: 50,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD648"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA5E1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_761_20386",
    x1: 10.9477,
    y1: 19.0303,
    x2: 13.8209,
    y2: 28.9603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD648"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA5E1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_761_20386",
    x1: 10.9477,
    y1: 19.0303,
    x2: 13.8209,
    y2: 28.9603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD648"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA5E1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_761_20386",
    x1: 10.9477,
    y1: 19.0303,
    x2: 13.8209,
    y2: 28.9603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD648"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA5E1B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_761_20386"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChat);
export default __webpack_public_path__ + "static/media/icon_chat.7ab7dd6598df59b20dea080dad22710e.svg";
export { ForwardRef as ReactComponent };